import { render, staticRenderFns } from "./TemperatureDataDownload.vue?vue&type=template&id=6d8298ea&scoped=true&"
import script from "./TemperatureDataDownload.vue?vue&type=script&lang=js&"
export * from "./TemperatureDataDownload.vue?vue&type=script&lang=js&"
import style0 from "./TemperatureDataDownload.vue?vue&type=style&index=0&id=6d8298ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8298ea",
  null
  
)

export default component.exports